"use strict";

exports.__esModule = true;
exports.usePie = void 0;

var _react = require("react");

var _get = _interopRequireDefault(require("lodash/get"));

var _d3Shape = require("d3-shape");

var _core = require("@nivo/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const usePie = ({
  data,
  radius,
  value = v => v,
  startAngle = 0,
  endAngle = 360,
  innerRadius = 0,
  cornerRadius = 0,
  sortByValue = false,
  padAngle = 0
}) => {
  const arcGenerator = (0, _react.useMemo)(() => (0, _d3Shape.arc)().outerRadius(radius).innerRadius(innerRadius).cornerRadius(cornerRadius), [radius, innerRadius, cornerRadius]);
  const getValue = (0, _react.useMemo)(() => typeof value === 'function' ? value : d => (0, _get.default)(d, value), [value]);
  const pie = (0, _react.useMemo)(() => {
    const computedPie = (0, _d3Shape.pie)().value(getValue).padAngle((0, _core.degreesToRadians)(padAngle)).startAngle((0, _core.degreesToRadians)(startAngle)).endAngle((0, _core.degreesToRadians)(endAngle));
    if (sortByValue !== true) computedPie.sortValues(null);
    return computedPie;
  }, [getValue, padAngle, startAngle, endAngle, sortByValue]);
  const arcs = (0, _react.useMemo)(() => pie(data).map(arc => {
    const angle = arc.endAngle - (arc.endAngle - arc.startAngle) * 0.5;
    return _extends({}, arc, {
      startAngleDeg: (0, _core.radiansToDegrees)(angle.startAngle),
      endAngleDeg: (0, _core.radiansToDegrees)(arc.endAngle),
      angle,
      angleDeg: (0, _core.radiansToDegrees)(angle)
    });
  }), [data, pie]);
  return {
    arcs,
    arcGenerator
  };
};

exports.usePie = usePie;